<template>
    <button class="js-close-preview post-preview__close-btn"></button>
</template>

<script>
    export default {
    }
</script>

<style scoped>
</style>
